(function () {
  'use strict';

  var nativeStillnessCartEnabled = false;
  var trayDiscountCode = 'STILLNESSTRAY10';

  function getDrawer() {
    return document.querySelector('m-cart-drawer');
  }

  function isStillnessCartActive(drawer) {
    return nativeStillnessCartEnabled && drawer && drawer.getAttribute('data-stillness-cart-active') === 'true';
  }

  function getSectionRequest(drawer) {
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return {};
    return {
      sections: drawer.getSectionsToRender().map(function (section) {
        return section.id;
      }),
      sections_url: window.location.pathname
    };
  }

  function renderCartState(drawer, state) {
    if (drawer && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
    }
    if (drawer && typeof drawer.updateCartCount === 'function') {
      drawer.updateCartCount(state.item_count);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: state }
    }));
  }

  function showDiscountMessage(form, applied) {
    if (!form) return;
    var message = form.querySelector('[data-stillness-discount-message]');
    if (!message) return;

    message.textContent = applied ? form.dataset.successMessage : form.dataset.invalidMessage;
    message.hidden = false;
    message.classList.toggle('is-success', applied);
    message.classList.toggle('is-error', !applied);
  }

  function removeTrayDiscountIfUnused(drawer, state) {
    var hasStillnessTray = state.items.some(function (item) {
      return item.properties &&
        item.properties['_Stillness Set group'] &&
        item.properties['_Stillness Set component'] === 'Tray';
    });
    if (hasStillnessTray) return Promise.resolve(state);

    var codes = (state.discount_codes || []).map(function (discount) {
      return discount.code;
    }).filter(function (code) {
      return code && code.toLowerCase() !== trayDiscountCode.toLowerCase();
    });
    var hadTrayDiscount = (state.discount_codes || []).some(function (discount) {
      return String(discount.code || '').toLowerCase() === trayDiscountCode.toLowerCase();
    });
    if (!hadTrayDiscount) return Promise.resolve(state);

    var requestBody = Object.assign({ discount: codes.join(',') }, getSectionRequest(drawer));
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(requestBody)
    }).then(function (response) {
      if (!response.ok) throw new Error('Discount removal failed');
      return response.json();
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.m-cart-icon-bubble');
    if (!trigger) return;

    var drawer = getDrawer();
    if (!isStillnessCartActive(drawer)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    drawer.open(trigger);
  }, true);

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-stillness-remove-group]');
    if (!removeButton) return;

    event.preventDefault();
    var drawer = getDrawer();
    var groupId = removeButton.getAttribute('data-stillness-remove-group');
    var groupCard = removeButton.closest('[data-stillness-cart-group]');
    removeButton.disabled = true;
    if (groupCard) groupCard.classList.add('is-loading');

    fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cartState) {
        var updates = {};
        cartState.items.forEach(function (item) {
          if (item.properties && item.properties['_Stillness Set group'] === groupId) {
            updates[item.key] = 0;
          }
        });

        var requestBody = Object.assign({ updates: updates }, getSectionRequest(drawer));
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(requestBody)
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function (state) {
        return removeTrayDiscountIfUnused(drawer, state);
      })
      .then(function (state) {
        var stillnessActive = state.items.some(function (item) {
          return item.properties && item.properties['_Stillness Set group'];
        });
        drawer.setAttribute('data-stillness-cart-active', stillnessActive ? 'true' : 'false');
        renderCartState(drawer, state);
      })
      .catch(function () {
        removeButton.disabled = false;
        if (groupCard) groupCard.classList.remove('is-loading');
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-stillness-discount-form]');
    if (!form) return;

    event.preventDefault();
    var drawer = getDrawer();
    var input = form.querySelector('[name="discount"]');
    var submit = form.querySelector('[type="submit"]');
    var message = form.querySelector('[data-stillness-discount-message]');
    var code = input.value.trim();

    if (!code) {
      message.textContent = form.dataset.invalidMessage;
      message.hidden = false;
      message.classList.add('is-error');
      return;
    }

    submit.disabled = true;
    form.classList.add('is-loading');
    message.hidden = true;
    message.classList.remove('is-error', 'is-success');

    var requestBody = Object.assign({ discount: code }, getSectionRequest(drawer));
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(requestBody)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Discount update failed');
        return response.json();
      })
      .then(function (state) {
        var normalizedCode = code.toLowerCase();
        var discountCodes = state.discount_codes || [];
        var discountApplications = state.discount_applications || [];
        var applied = discountCodes.some(function (discount) {
          return String(discount.code || '').toLowerCase() === normalizedCode && discount.applicable !== false;
        }) || discountApplications.some(function (discount) {
          return String(discount.title || '').toLowerCase() === normalizedCode;
        });

        renderCartState(drawer, state);
        requestAnimationFrame(function () {
          showDiscountMessage(
            document.querySelector('[data-stillness-discount-form]'),
            applied
          );
        });
      })
      .catch(function () {
        message.textContent = form.dataset.errorMessage;
        message.hidden = false;
        message.classList.add('is-error');
      })
      .finally(function () {
        submit.disabled = false;
        form.classList.remove('is-loading');
      });
  });
})();
